import cn from 'classnames'
import React, { ReactElement } from 'react'

import BackButton from '@components/BackButton'
import bem from '@lib/bem'
import { useTranslation } from '@lib/i18n'
import { useParams } from '@stores/params'

import '@pages/Checkout/index.scss'

export const BackNavigation = (): ReactElement => {
  const { t } = useTranslation()
  const [params] = useParams()
  return (
    <div className="cell">
      <BackButton
        title={t('checkout.backButton')}
        className={cn(bem('checkout', 'back-navigation', { express: params.express }), params.mode)}
      />
    </div>
  )
}
